export function getDiscountRateText({
  discountRate = 0,
  setDiscountRate = 0,
}: {
  discountRate?: number;
  setDiscountRate?: number;
}) {
  if (!discountRate && !setDiscountRate) {
    return;
  }

  if (discountRate < setDiscountRate) {
    return `~${setDiscountRate}%`;
  }

  return `${discountRate}%`;
}
